import React, { PureComponent, Fragment } from 'react';
import { NormalizedSeries } from 'types';
import { getSeriesValue, getSeriesLabel } from './utils';
// Components
import styles from './chart.scss';
import { round } from 'helpers/math';
import { calculatePointAt } from 'helpers/chart';

interface PointTooltipProps {
  series: NormalizedSeries[];
  current: number;
  range: [number, number];
  height: number;
  width: number;
}
export default class PointTooltip extends PureComponent<PointTooltipProps> {
  handleClick = () => {
    console.log('PROMT TO ADD FLAG');
  };

  render() {
    const { series, width, height, range, current } = this.props;
    let dRange = range[1] - range[0];

    const currentX = range[0] + dRange * current;
    let avgY = 0;
    let seriesY = [];
    for (let s of series) {
      let y = calculatePointAt(currentX, s.points);
      avgY += y;
      seriesY.push(y);
    }

    avgY /= series.length;
    let x = ((currentX - range[0]) / dRange) * width;
    let y = height - avgY * height;

    return (
      <>
        <g
          onDoubleClick={this.handleClick}
          transform={`translate(${x || 0},${0})`}
          className={styles.tooltip}
        >
          {series.map((s, index) => (
            <Fragment key={s.id}>
              <circle
                r={8}
                fill={s.color}
                opacity={0.3}
                cx={0}
                cy={(1 - seriesY[index]) * height}
              />
              <circle
                r={4}
                fill={s.color}
                cx={0}
                cy={(1 - seriesY[index]) * height}
                stroke="white"
              />
            </Fragment>
          ))}
          <g
            transform={`translate(${x < 200 ? 120 : 0}, ${y || 0})`}
            style={{ transition: 'all 0.3s' }}
          >
            <rect
              x={-110}
              y={-12}
              width={100}
              height={1.3 * series.length + 'em'}
              fill="rgba(255,255,255,0.9)"
            />
            <text x={-20} y={0} textAnchor="end">
              {series.map((s, index) => (
                <tspan key={s.id} x={-10} y={1.2 * index + 'em'} fill={s.color}>
                  <tspan className={styles.label}>{s.name || s.id}:</tspan>
                  <tspan className={styles.value}>{getSeriesValue(s, seriesY[index])}</tspan>
                </tspan>
              ))}
            </text>
          </g>
        </g>
      </>
    );
  }
}
